export default __webpack_public_path__ + "static/media/calendar-inactive-icon.1cad8296.svg";